module.exports = __webpack_public_path__ + "media/assets/round_btn_hover-74efe9e75fcc4477d85161c98be80898.png";